import {includes} from "lodash"

import {commandeStatut} from "./commande"
import {Page} from "./page/pages"
import {PagesArchitecture} from "./page/pagesArchitecture"

export const orderLayoutPath = "/demande"

export const demandeSteps = (
    noInfoComp,
    noAttrib,
    noModesPaiement,
    modeFacturation,
    attributionStatus,
    actualPage,
    texts,
) => [
    {
        name: PagesArchitecture[Page.CREATION_DEMANDE_NOS_PRESTATIONS].breadcrumbText,
        page: Page.CREATION_DEMANDE_NOS_PRESTATIONS,
        clickable: includes(
            [
                Page.CREATION_DEMANDE_INFORMATIONS_COMPLEMENTAIRES,
                Page.CREATION_DEMANDE_QUESTIONS_ATTRIBUTION,
                Page.CREATION_DEMANDE_CHOIX_PRESTATION,
                Page.CREATION_DEMANDE_DETAILS_PRESTATION,
                Page.CREATION_DEMANDE_INFORMATIONS_PAIEMENT,
                Page.CREATION_DEMANDE_CONFIRMATION,
            ],
            actualPage,
        ),
    },
    {
        name: PagesArchitecture[Page.CREATION_DEMANDE_INFORMATIONS_COMPLEMENTAIRES].breadcrumbText,
        page: Page.CREATION_DEMANDE_INFORMATIONS_COMPLEMENTAIRES,
        hide: noInfoComp,
        clickable: includes(
            [
                Page.CREATION_DEMANDE_QUESTIONS_ATTRIBUTION,
                Page.CREATION_DEMANDE_CHOIX_PRESTATION,
                Page.CREATION_DEMANDE_DETAILS_PRESTATION,
                Page.CREATION_DEMANDE_INFORMATIONS_PAIEMENT,
                Page.CREATION_DEMANDE_CONFIRMATION,
            ],
            actualPage,
        ),
    },
    {
        name: PagesArchitecture[Page.CREATION_DEMANDE_QUESTIONS_ATTRIBUTION].breadcrumbText,
        page: Page.CREATION_DEMANDE_QUESTIONS_ATTRIBUTION,
        hide: noAttrib,
        clickable: includes(
            [
                Page.CREATION_DEMANDE_CHOIX_PRESTATION,
                Page.CREATION_DEMANDE_DETAILS_PRESTATION,
                Page.CREATION_DEMANDE_INFORMATIONS_PAIEMENT,
                Page.CREATION_DEMANDE_CONFIRMATION,
            ],
            actualPage,
        ),
    },
    {
        name: PagesArchitecture[Page.CREATION_DEMANDE_CHOIX_PRESTATION].breadcrumbText,
        page: Page.CREATION_DEMANDE_CHOIX_PRESTATION,
        hide: attributionStatus === commandeStatut.REFUSEE,
        clickable: includes(
            [
                Page.CREATION_DEMANDE_DETAILS_PRESTATION,
                Page.CREATION_DEMANDE_INFORMATIONS_PAIEMENT,
                Page.CREATION_DEMANDE_CONFIRMATION,
            ],
            actualPage,
        ),
    },
    {
        name: PagesArchitecture[Page.CREATION_DEMANDE_DETAILS_PRESTATION].breadcrumbText,
        page: Page.CREATION_DEMANDE_DETAILS_PRESTATION,
        hide: attributionStatus === commandeStatut.REFUSEE,
        clickable: includes(
            [Page.CREATION_DEMANDE_INFORMATIONS_PAIEMENT, Page.CREATION_DEMANDE_CONFIRMATION],
            actualPage,
        ),
    },
    {
        name: PagesArchitecture[Page.CREATION_DEMANDE_INFORMATIONS_PAIEMENT].breadcrumbText,
        page: Page.CREATION_DEMANDE_INFORMATIONS_PAIEMENT,
        hide: noModesPaiement,
        clickable: includes([Page.CREATION_DEMANDE_CONFIRMATION], actualPage),
    },
    {
        name:
            attributionStatus === commandeStatut.REFUSEE
                ? texts.tabConfirmationAttributionRefusee
                : PagesArchitecture[Page.CREATION_DEMANDE_CONFIRMATION].breadcrumbText,
        page: Page.CREATION_DEMANDE_CONFIRMATION,
    },
]
